import bindAllOfThis from 'src/utils/BindThisHelper';
import { PhaserGeneralGameObjectType, TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Pet, PetHome, PetItem } from '../objects/Pet';
import TranslateApi from 'src/utils/TranslateHelper';
import { PhaserButtonConfig } from 'src/games/shared/Button';
import { PhaserModalConfig, PhaserModal } from 'src/games/shared/Modal';
import { Color } from 'src/games/shared/ColorValue';
import { EndGameScene } from './EndGameScene';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    pets: Pet[];
    items: PetItem[];
    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload(): void {
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/space_pets.json"));
        this.load.image('background', require('/src/assets/qci/backgrounds/1c_background.png'));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameSpacePets.png"), require("src/assets/qci/atlas/gameSpacePets.json"));
    }

    initialize(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.pets = [];
        this.items = [];
    }

    create(): void {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createHomes();
        this.createShelf();
        this.createPets();
        this.registerEvents();
    }

    createShelf() {
        var id = 0;
        this.map.getObjectLayer("Shelf").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "shelf") {
                var shelf = this.add.sprite(ob.x, ob.y, "assets", "counter");
                shelf.setOrigin(0);
                shelf.name = "shelf";
                shelf.setInteractive();
                shelf.input.dropZone = true;
            }
            else if (ob.type === "PetItem") {
                this.createPetItem(ob, id++);
            }
        });
    }

    createHomes() {
        this.map.getObjectLayer("Homes").objects.forEach((ob: TiledGameObject) => {
            var home = new PetHome(this, ob);
        });
    }

    createPets() {
        var id = 0;
        this.map.getObjectLayer("Pets").objects.forEach((ob: TiledGameObject) => {
            var pet = new Pet(this, ob, id++);
            this.pets.push(pet);
        });
    }

    createPetItem(ob: TiledGameObject, id: number) {
        var item = new PetItem(this, ob, id);
        this.items.push(item);
    }

    registerEvents(): void {
        this.input.dragDistanceThreshold = 10;

        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, gameObject: Pet | PetItem) => {
            this.children.bringToTop(gameObject);
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, gameObject: Pet | PetItem, dragX: number, dragY: number) => {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, gameObject: Pet | PetItem, dropped: boolean) => {
            if (!dropped) {
                // Put back
                gameObject.x = gameObject.input.dragStartX;
                gameObject.y = gameObject.input.dragStartY;
            }
        });

        this.input.on('drop', (pointer: Phaser.Input.Pointer, gameObject: Pet | PetItem, zone) => {
            if (zone.name === "shelf") {
                gameObject.setPosition(gameObject.startingPosition.x, gameObject.startingPosition.y);
                return;
            }
            else {
                var home = zone as PetHome;
                this.drop(gameObject, home);
            }
        });

    }

    drop(gameObject: Pet | PetItem, home: PetHome) {
        this.children.bringToTop(gameObject);

        if (gameObject.type === "Pet") {
            var pet = gameObject as Pet;
            home.isOccupied = true;
        }
        else if (gameObject.type === "PetItem") {
            var item = gameObject as PetItem;
            home.items.add(item);
        }

        // They are locked into their home
        if (gameObject.homeId === home.id) {
            gameObject.isHome = true;
            gameObject.input.enabled = false;

            // Change to the rightful frame
            home.updateHome(gameObject);
            gameObject.destroy();
        }
        else {
            // Ensure that the misplaced item is on top of everything so it can always be moved
            gameObject.setDepth(5);
            gameObject.isHome = false;
        }

        this.isGameOver();
    }

    isGameOver(): boolean {
        var pet: Pet;

        for (pet of this.pets) {
            if (!pet.isHome) {
                return false;
            }
        }

        var item: PetItem;
        for (item of this.items) {
            if (!item.isHome) {
                return false;
            }
        }

        // Wait a second and then end the game
        setTimeout(() => {
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        }, 1000);

        return true;
    }

    modal(translationKey: string) {
        var text = TranslateApi.translate("SpacePets.Phaser." + translationKey);

        var buttonConfig: PhaserButtonConfig = {
            smartSize: true,
            backgroundColor: Color.KUDER_SECONDARY_BUTTON
        };

        var config: PhaserModalConfig = {
            title: text,
            buttonWidth: 50,
            buttonConfig: buttonConfig
        };

        var options = [{ id: 1, displayText: TranslateApi.translate("common.ok") }];
        var modal = new PhaserModal(this, 0, 0, options, config);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on("optionClicked", () => {
            modal.destroy();
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/SpacePets/scenes/MainScene.ts